exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.thumbnail { \n  width: 80px;\n  height: 80px;\n  border-radius: 100%;\n  background-size: cover;\n}\n\n.card { \n  margin-bottom: 80px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/dev1/Aladin-SHOP/src/app/shopping/components/shopping-cart/shopping-cart.component.css
// module id = ../../../../../src/app/shopping/components/shopping-cart/shopping-cart.component.css
// module chunks = main